import { render, staticRenderFns } from "./HeaderBanner.vue?vue&type=template&id=38b06680&scoped=true&"
import script from "./HeaderBanner.vue?vue&type=script&lang=js&"
export * from "./HeaderBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBanner.vue?vue&type=style&index=0&id=38b06680&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b06680",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BButton, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BButton, BRow, BContainer})
    

export default component.exports